import Constants from '@/lib/constants';

export default function buildUrl(endpoint, fullyQualified=false, domain=Constants.WEBSITE_URL) {
    return (fullyQualified ? 'https://' : '') + domain + endpoint;
}
